DetailOutput = App.loadClass "core::reports/DetailOutput"
BaseOutput = App.loadClass "core::reports/BaseOutput"
BaseHandler = App.loadClass "core::reports/BaseHandler"

class exports.Reports_Competitors_SubHandler extends BaseHandler
    init: () ->
        @layoutSelector = "#reports_competitors_tab"
        @excelUrl       = 'backend/portal/reports/competitors/excel'
        @filterUrl      = 'backend/portal/reports/competitors/filters'

        @initFilters()


    initFilters: () ->
        @resetFilters()

        @parent.filters.importGroup
            name: "Competitors Filters"
            filters: [
                {
                    name: 'account_types'
                    display_name: 'Account Type'
                    class: 'dropup'
                },
                {
                    name: 'competitors'
                    display_name: 'Competitors'
                    class: 'dropup'
                },
                {
                    name: 'methods'
                    display_name: 'Contact Method'
                    class: 'dropup'
                    control_type: 'single_dropdown'
                    deletable: false
                    values: [
                        { key: 'Email', value: 'Email + TouchPoint' }
                        { key: 'SMS', value: 'SMS + TouchPoint' }
                        { key: 'TouchPoint', value: 'TouchPoint' }
                    ],
                    selected_values: [
                        { key: 'TouchPoint', value: 'TouchPoint' }
                    ],
                },
                {
                    name: 'output_type'
                    display_name: 'Output Type'
                    control_type: 'option'
                    deletable: false
                    values: [
                        { key: 'detail', value: 'Detail' },
                        { key: 'summary', value: 'Summary' }
                    ],
                    selected_values: [
                        { key: 'detail', value: 'Detail' }
                    ],
                },
            ]

        # customize filters
        @parent.filters.assignGroupName("Competitors Filters", "")
        @parent.filters.findInGroup('fields').disableFilter()
        @parent.filters.findInGroup('farms').disableFilter()
        @parent.filters.moveFilter('owners', "Competitors Filters", 'output_type')
        @parent.filters.findInGroup('owners').class('dropup')

        @parent.dialog.find('.email-btn').show()

        # when emial is clicked get filters and init communicate page
        @parent.dialog.delegate '.email-btn', 'click', () =>
            @goToCommunicatePage()

        @setDefaultsAndRun()


    # Yes its as gross as the name makes it sound
    goToCommunicatePage: () ->
        @parent.dialog.empty()

        # change selected navigation...nasty!
        primary_nav = $(document).find('#nav_primary_links')
        primary_nav.find('li.active').removeClass('active')
        primary_nav.find("a[data-page-name='communicate']").closest('li').addClass('active')

        # init communicate
        communicate_handler = @createSubHandler 'portal::handlers/communicate/Communicate_Handler'
        if communicate_handler
            ignoreFilters = ['output_type']
            communicate_handler.init(@filterUrl, @parent.filters.exportStructure(ignoreFilters))


    destroy: () ->
        # Reset filters
        @parent.filters.findInGroup('fields').enableFilter()
        @parent.filters.findInGroup('farms').enableFilter()
        @parent.filters.moveFilter('owners', "Operation Filters", 'farms')
        @parent.filters.findInGroup('owners').class('dropdown')
        @parent.filters.removeGroup "Competitors Filters"

        @parent.dialog.find('.email-btn').hide()
        super()

    beforeApply: () ->
        filters = @parent.filters.jsonize()

        if filters.filters.output_type[0].key is 'detail'
            @layoutUrl  = 'backend/portal/reports/competitors/table/detail'
            @printUrl   = 'backend/portal/reports/competitors/print/detail'
            @currentOutput = new DetailOutput this, @parent, 600, { sAjaxSource: 'backend/portal/reports/competitors/output/detail' }
        else
            @layoutUrl  = 'backend/portal/reports/competitors/output/summary'
            @printUrl   = 'backend/portal/reports/competitors/print/summary'
            @currentOutput = new BaseOutput this, @parent
